import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routes from './oauthDone.routes';

import params from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

export class OauthDoneComponent {
  constructor($scope, $state, $http, $uibModal) {

  }
}

OauthDoneComponent.$inject = ['$scope', '$state', '$http', '$uibModal'];

export default angular.module('syncplicityLoginApp', [uiRouter])
  .config(routes)
  .component('oauthDone', {
    template: require('./oauthDone.html'),
    controller: OauthDoneComponent    
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/oauthDone/oauthDone.component.js